import { useUser } from "~/context/userContext";
import { useRouter } from "next/router";
import Page from "~/components/Page";
import { Display02 } from "~/components/Texts";
import MyShops from "~/components/MyShops";
import { Box, Center, VStack, useColorModeValue } from "@chakra-ui/react";
import Spinner from "~/components/animations/Spinner";
import Logo from "~/components/logo";

export default function MyShopsPage() {
  const { user, loadingUser } = useUser();
  const router = useRouter();

  return (
    <Page allowLoggedUsersOnly title="Mis tiendas | Shop Story">
      {loadingUser && (
        <Center w="100vw" h="100vh">
          <Spinner />
        </Center>
      )}
      {!loadingUser && user && (
        <Box
          w="100vw"
          h="100vh"
          p="5%"
          backgroundColor={useColorModeValue(
            "light.background.strong",
            "dark.background.strong"
          )}
        >
          <VStack w="100%" h="100%" align="flex-start">
            <Box mb="8">
              <Logo />
            </Box>
            <VStack
              w="100%"
              h="100%"
              p="8"
              spacing="20"
              align="flex-start"
              backgroundColor={useColorModeValue(
                "light.background.superLite",
                "dark.background.superLite"
              )}
              borderRadius="brand"
            >
              <Display02>Tus tiendas</Display02>
              <Box w="100%" h="auto">
                <MyShops
                  direction="row"
                  onNewShopSelect={() => router.push("/onboarding")}
                  onExistingShopSelect={(shop) =>
                    router.push(
                      "/[shopDomain]/control",
                      "/" + shop.domains[0] + "/control"
                    )
                  }
                />
              </Box>
            </VStack>
          </VStack>
        </Box>
      )}
    </Page>
  );
}
